import { Component, OnInit, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { Message, SelectItem, MessagesModule } from 'primeng/primeng';
import { Router, ActivatedRoute, Params, Data } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from '../api.service';
import { EncryptingService } from '../encrypting.service';
import { StoreService } from '../store.service';
import './login.component.css';
import { async } from '@angular/core/testing';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  providers: [ApiService, EncryptingService],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {

  public loginform: FormGroup;
  showPassword: boolean = false;
  public loading: boolean;
  public msgs: Message[] = [];
  code: string;
  public responseDB: any;
  loadingMessage: string = "Please wait...";
  public currentYear: number;
  @Output() talk: EventEmitter<string> = new EventEmitter<string>();

  constructor(private fb: FormBuilder, private router: Router, private spinner: NgxSpinnerService,
    private api: ApiService, private encrypt: EncryptingService, private ss: StoreService, private route: ActivatedRoute) {
    this.loginform = this.fb.group({
      UserName: ["", Validators.required],
      Password: ["", Validators.required]
    });

  }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    this.route.params.subscribe(params => {
      this.code = params['code'];
      console.log(params['code']);
    });

    var token = this.ss.fetchToken();
    if(this.code!=null){
      this.msgs.push({ severity: 'success', summary: '', detail: 'Connection to Reckon data file is successful, please Re login.' });

   }
    if (!this.code || !token) {

      this.ss.clearAll();
      this.talk.emit('out');
      
    }
    else {
      this.getAccessToken(token);
    }
  }


  txtFocus() {
    this.msgs = [];
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }


  onSubmit(value: any) {
    var decrptPwd = this.encrypt.decrypt("P+ySFEDBKhM8pQ39yZZWFQ==");
    console.log(decrptPwd);
    this.msgs = [];
    if (this.loginform.valid) {
      event.preventDefault();
      this.loading = true;
      this.spinner.show();
      this.ss.storeUserName(this.loginform.value.UserName);
      var loginData = { 'UserName': this.loginform.value.UserName, 'Password': this.encrypt.encrypt(this.loginform.value.Password) }
           console.log('loginpassword',loginData.Password);
      this.api.postAsEndUser('login/DoLogin', loginData).subscribe(
        (res: {}) => this.validateSave(res),
        error => this.validateSave(<any>error));

    }
  }

  validateError(res: any) {
    this.loading = false;
    this.spinner.hide();
    this.msgs.push({ severity: 'error', summary: 'Oops..', detail: 'Invalid Credentials' });
  }

  validateSave(res: any) {
    this.spinner.hide();

    console.log(res);
    this.loading = false;
    if (res.StatusCode == 0) {

      this.ss.storeToken(res.Data.Token.toString());
      this.ss.storeEmail(res.Data.EmailAddress.toString());
      this.ss.storeAccountID(res.Data.AccountID);

      this.getRahDetail();


    } else {
      this.msgs.push({ severity: 'error', summary: 'Oops..', detail: 'Incorrect credentials' });
    }
  }

  getRahDetail() {
    this.msgs = [];
    this.spinner.show();
    var accountID = this.ss.fetchAccountID();

    this.api.get('Rah/GetRahByID?accountID=' + accountID, '').subscribe(
      (res: {}) => this.sucessGetRah(res),
      error => this.failedGetRah(<any>error));
  }

  sucessGetRah(resp: any) {
    this.spinner.hide();
   console.log('Rah/GetRahByID?accountID');
   console.log(resp);
    if (resp.Data != null) {
      if (resp.Data.RahVerified == true) {
        this.ss.storeQboConnectID(resp.Data.RahID);
        this.ss.storeAccountRahMaster(resp.Data);
        var token = this.ss.fetchToken();
        this.router.navigate(['/initlogin/' + token.toString() + '/0/login']);
      }
      else {
        this.router.navigate(['/rahsetting']);
      }
    }
    else {
      if (this.code == undefined) {
        var token = this.ss.fetchToken();
        this.router.navigate(['/initlogin/' + token.toString() + '/0/login']);
      }
      else {
        var token = this.ss.fetchToken();
        this.getAccessToken(token);
        // this.api.get('Rah/GetAccessTokenByCode?code=' + this.code + "&token=" + token.toString(), '').subscribe(
        //   (res: {}) => this.sucessGetRahCode(res),
        //   error => this.failedGetRahCode(<any>error));
      }

    }

  }

  failedGetRah(resp: any) {
    console.log(resp);
    this.spinner.hide();
  }

  validateRah(resp: any) {
    if (resp.Success == true) {
      this.spinner.hide();
    
    }
  }

  sucessGetRahCode(resp: any) {

    console.log("Code resp");
    console.log(resp);
    this.router.navigate(['/rahsetting']);
    // this.spinner.hide();
  }

  failedGetRahCode(resp: any) {
    console.log(resp);
    this.spinner.hide();
  }

  getAccessToken(token){
    this.api.get('Rah/GetAccessTokenByCode?code=' + this.code + "&token=" + token.toString(), '').subscribe(
      (res: {}) => this.sucessGetRahCode(res),
      error => this.failedGetRahCode(<any>error));
  }

}


